import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { ChildContactInfoSubmitter } from '../../lib/child-contact-info/child-contact-info-submit.service'

export class DocsChildContactInfoSubmitter implements ChildContactInfoSubmitter {
  public submit(): void {
    alert('Navigate to parent-guardian-info')
  }
  public reset(store: StoreService): void {
    // noop
  }
}
